const PublicationAnalysisMethodNote = ({ compact = false, inverted = false }) => {
  return (
    <div className={`publication-analysis-note ${compact ? 'publication-analysis-note-compact' : ''} ${inverted ? 'publication-analysis-note-inverted' : ''}`}>
      <div className="publication-analysis-note-icon" aria-hidden="true">
        <i className="fas fa-exclamation-triangle"></i>
      </div>
      <div>
        <p className="publication-analysis-note-title">NB: chart colors are local to each chart.</p>
        <p>
          Colors group related themes within a single chart, but they are not synchronized across land uses. When comparing Agriculture, Forest, and Urban charts, use the labels and values rather than matching colors across charts.
        </p>
        {!compact && (
          <p>
            These charts were produced with language-model assisted text analysis. For each land-use context, workshop responses were pooled to identify recurring themes and thematic groups. Each workshop was then scored on a 0-5 scale for how strongly each theme was directly expressed; repeated scoring runs, when present, are averaged. Land-use overview charts sum workshop scores and rescale them to the radar-chart radius.
          </p>
        )}
      </div>
    </div>
  );
};

export default PublicationAnalysisMethodNote;
